import { useCallback } from 'react';
import { createProcessPayload } from '../utils/chunkUtils';
import { apiFetch } from '../../../auth/apiFetch';

export const useChunkProcessing = (apiBaseUrl, setDocuments) => {
  const handleSaveAndProcess = useCallback(async ({ chunks, metadata }, doc) => {
    setDocuments((prev) =>
      prev.map((d) =>
        d.id === doc.id ? { ...d, status: 'processing' } : d
      )
    );

    try {
      const payload = createProcessPayload(doc, chunks, metadata);
      
      console.log('Full payload:', payload);
      payload.chunks.forEach(chunk => console.log('Sending chunk:', chunk));

      const response = await apiFetch(`${apiBaseUrl}/api/process-chunks`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error('Failed to process PDF with custom chunks');

      const data = await response.json();
      const url = data.download_url;

      setDocuments((prev) =>
        prev.map((d) =>
          d.id === doc.id
            ? { ...d, status: 'completed', downloadUrl: url }
            : d
        )
      );
    } catch (err) {
      console.error(err);
      setDocuments((prev) =>
        prev.map((d) =>
          d.id === doc.id ? { ...d, status: 'error' } : d
        )
      );
    }
  }, [apiBaseUrl, setDocuments]);

  return { handleSaveAndProcess };
};
